var _rect, _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _path12, _g7, _path13, _g8, _path14, _path15, _g9, _path16, _path17, _g0, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_10010_23954)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4548 15.2375C18.4548 15.2375 26.5379 14.6837 26.5929 23.3744C17.9019 23.3192 18.4548 15.2375 18.4548 15.2375Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 11,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9551 14.5371H27.2415V23.9219H17.9551V14.5371Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0653 23.8512L26.59 23.8487C23.7868 23.8299 21.6066 23.0042 20.1093 21.3904C17.7652 18.8656 17.9766 15.3573 17.9866 15.2095L18.0141 14.8022L18.4231 14.7734C18.4231 14.7734 18.5382 14.7646 18.7408 14.7646C20.1218 14.7646 27.0103 15.1806 27.0628 23.3751L27.0653 23.8512Z",
    fill: "url(#paint1_linear_10010_23954)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 5,
    width: 8,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6797 5.99707H31.4043V19.0268H24.6797V5.99707Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0813 18.8623L27.7473 18.524C25.7772 16.5293 24.8203 14.403 24.9029 12.204C25.0317 8.76086 27.661 6.43032 27.7736 6.33384L28.0813 6.06445L28.3903 6.33384C28.5028 6.43032 31.1322 8.76086 31.261 12.204C31.3435 14.403 30.3866 16.5293 28.4165 18.524L28.0813 18.8623Z",
    fill: "url(#paint2_linear_10010_23954)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9369 15.2375C37.9369 15.2375 29.8551 14.6837 29.7988 23.3744C38.4911 23.3192 37.9369 15.2375 37.9369 15.2375Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 14,
    width: 10,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1626 14.5371H38.449V23.9219H29.1626V14.5371Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3262 23.8512L29.3299 23.3751C29.3825 15.1806 36.2709 14.7646 37.6506 14.7646C37.8545 14.7646 37.9696 14.7734 37.9696 14.7734L38.3774 14.8022L38.4062 15.2095C38.4162 15.3573 38.6276 18.8644 36.2835 21.3904C34.7874 23.0042 32.6059 23.8299 29.8015 23.8487L29.3262 23.8512Z",
    fill: "url(#paint3_linear_10010_23954)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 19,
    width: 23,
    height: 26
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 19.8721H39.0875V44.9742H17.3125V19.8721Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10010_23954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 19,
    width: 22,
    height: 26
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1068 44.9757V19.8937C32.033 19.8887 31.9604 19.8887 31.8866 19.8887H24.5216V44.9757H32.1068ZM22.634 44.9757H24.5216V19.8937H24.4803C21.4282 19.8937 18.7489 22.3884 18.5287 25.4343L17.4967 39.4414C17.2703 42.4811 19.5832 44.9757 22.634 44.9757ZM33.7317 44.9757C36.7838 44.9757 39.0953 42.4811 38.8702 39.4351L37.837 25.4293C37.6168 22.4573 35.0588 20.0102 32.1018 19.8937V44.9757H33.7317Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8858 44.9761H17.4961V19.874H38.8858V44.9761Z",
    fill: "#FFDE59"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 19,
    width: 11,
    height: 11
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9985 19.2383H26.7477V29.004H16.9985V19.2383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_10010_23954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 19,
    width: 11,
    height: 11
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8731 19.2393C19.1813 19.2393 16.9985 21.4244 16.9985 24.1221C16.9985 26.8185 19.1813 29.005 21.8731 29.005C24.565 29.005 26.7477 26.8185 26.7477 24.1221C26.7477 21.4244 24.565 19.2393 21.8731 19.2393Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9985 19.2393H26.7477V29.005H16.9985V19.2393Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 21,
    width: 7,
    height: 7
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8374 21.0684H24.9166V27.1591H18.8374V21.0684Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_10010_23954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 21,
    width: 7,
    height: 7
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8785 21.0674C20.1998 21.0674 18.8389 22.4306 18.8389 24.1134C18.8389 25.7949 20.1998 27.1581 21.8785 27.1581C23.5571 27.1581 24.918 25.7949 24.918 24.1134C24.918 22.4306 23.5571 21.0674 21.8785 21.0674Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8389 21.0674H24.918V27.1581H18.8389V21.0674Z",
    fill: "#3D1F1E"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7602 24.6368C20.7602 23.904 21.3057 23.3756 22.0214 23.3756C21.3389 23.3756 20.7608 22.8129 20.7608 22.1139C20.7608 22.8062 20.2212 23.3756 19.499 23.3756C20.2212 23.3756 20.7602 23.9306 20.7602 24.6368Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7602 22.1133L20.7608 22.1139M20.7608 22.1139C20.7608 22.8129 21.3389 23.3756 22.0214 23.3756C21.3057 23.3756 20.7602 23.904 20.7602 24.6368C20.7602 23.9306 20.2212 23.3756 19.499 23.3756C20.2212 23.3756 20.7608 22.8062 20.7608 22.1139Z",
    stroke: "white",
    strokeWidth: 0.403264,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 34,
    width: 7,
    height: 4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3159 34.6328H31.1341V37.2483H25.3159V34.6328Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2253 37.9333C28.0343 37.9333 27.8454 37.9229 27.6586 37.9016C27.4708 37.8807 27.2893 37.8493 27.1131 37.8079C26.9369 37.7661 26.7691 37.7156 26.6109 37.6554C26.4515 37.5952 26.3049 37.5267 26.1698 37.4502C26.0347 37.3733 25.9144 37.2901 25.8089 37.1998C25.7024 37.11 25.6127 37.0147 25.5399 36.9144C25.4671 36.8145 25.4122 36.7112 25.3742 36.6051C25.3373 36.4985 25.3193 36.3915 25.3193 36.2829C25.3193 36.1746 25.3373 36.0672 25.3742 35.961C25.4122 35.8549 25.4671 35.7516 25.5399 35.6513C25.6127 35.5515 25.7024 35.4562 25.8089 35.3663C25.9144 35.276 26.0347 35.1929 26.1698 35.116C26.3049 35.0395 26.4515 34.9709 26.6109 34.9107C26.7691 34.8506 26.9369 34.8 27.1131 34.7582C27.2893 34.7168 27.4708 34.6855 27.6586 34.6646C27.8454 34.6433 28.0343 34.6328 28.2253 34.6328C28.4162 34.6328 28.6051 34.6433 28.7919 34.6646C28.9797 34.6855 29.1612 34.7168 29.3374 34.7582C29.5136 34.8 29.6814 34.8506 29.8397 34.9107C29.999 34.9709 30.1457 35.0395 30.2807 35.116C30.4158 35.1929 30.5361 35.276 30.6416 35.3663C30.7482 35.4562 30.8378 35.5515 30.9106 35.6513C30.9835 35.7516 31.0383 35.8549 31.0763 35.961C31.1132 36.0672 31.1312 36.1746 31.1312 36.2829C31.1312 36.3915 31.1132 36.4985 31.0763 36.6051C31.0383 36.7112 30.9835 36.8145 30.9106 36.9144C30.8378 37.0147 30.7482 37.11 30.6416 37.1998C30.5361 37.2901 30.4158 37.3733 30.2807 37.4502C30.1457 37.5267 29.999 37.5952 29.8397 37.6554C29.6814 37.7156 29.5136 37.7661 29.3374 37.8079C29.1612 37.8493 28.9797 37.8807 28.7919 37.9016C28.6051 37.9229 28.4162 37.9333 28.2253 37.9333Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 36,
    width: 6,
    height: 2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9082 36.9541H30.5424V37.5413H25.9082V36.9541Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5424 37.2476C30.5424 37.2668 30.5268 37.2858 30.4977 37.3049C30.4675 37.3237 30.4238 37.342 30.3655 37.3599C30.3072 37.3777 30.2362 37.3945 30.1517 37.4106C30.0671 37.4265 29.9709 37.4414 29.863 37.455C29.7561 37.4687 29.6385 37.4808 29.5121 37.4915C29.3858 37.5023 29.2526 37.5112 29.1117 37.5185C28.9708 37.5259 28.8259 37.5316 28.6772 37.5353C28.5276 37.5391 28.3769 37.541 28.2253 37.541C28.0727 37.541 27.922 37.5391 27.7733 37.5353C27.6237 37.5316 27.4788 37.5259 27.3379 37.5185C27.198 37.5112 27.0638 37.5023 26.9375 37.4915C26.8111 37.4808 26.6935 37.4687 26.5866 37.455C26.4787 37.4414 26.3825 37.4265 26.2979 37.4106C26.2134 37.3945 26.1424 37.3777 26.0841 37.3599C26.0258 37.342 25.9821 37.3237 25.9519 37.3049C25.9228 37.2858 25.9082 37.2668 25.9082 37.2476C25.9082 37.2283 25.9228 37.2092 25.9519 37.1902C25.9821 37.1714 26.0258 37.153 26.0841 37.1352C26.1424 37.1174 26.2134 37.1006 26.2979 37.0845C26.3825 37.0686 26.4787 37.0537 26.5866 37.0401C26.6935 37.0264 26.8111 37.0142 26.9375 37.0036C27.0638 36.9928 27.198 36.9839 27.3379 36.9765C27.4788 36.9692 27.6237 36.9635 27.7733 36.9598C27.922 36.956 28.0727 36.9541 28.2253 36.9541C28.3769 36.9541 28.5276 36.956 28.6772 36.9598C28.8259 36.9635 28.9708 36.9692 29.1117 36.9765C29.2526 36.9839 29.3858 36.9928 29.5121 37.0036C29.6385 37.0142 29.7561 37.0264 29.863 37.0401C29.9709 37.0537 30.0671 37.0686 30.1517 37.0845C30.2362 37.1006 30.3072 37.1174 30.3655 37.1352C30.4238 37.153 30.4675 37.1714 30.4977 37.1902C30.5268 37.2092 30.5424 37.2283 30.5424 37.2476Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 19,
    width: 11,
    height: 11
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 19.2383H39.3742V29.004H29.625V19.2383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_10010_23954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 19,
    width: 11,
    height: 11
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4996 19.2393C31.8065 19.2393 29.625 21.4244 29.625 24.1221C29.625 26.8185 31.8065 29.005 34.4996 29.005C37.1915 29.005 39.3742 26.8185 39.3742 24.1221C39.3742 21.4244 37.1915 19.2393 34.4996 19.2393Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.625 19.2393H39.3742V29.005H29.625V19.2393Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 21,
    width: 7,
    height: 7
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4551 21.0684H37.5355V27.1591H31.4551V21.0684Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_10010_23954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_10010_23954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 21,
    width: 7,
    height: 7
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4959 21.0684C32.816 21.0684 31.4551 22.4316 31.4551 24.1143C31.4551 25.7958 32.816 27.1591 34.4959 27.1591C36.1746 27.1591 37.5355 25.7958 37.5355 24.1143C37.5355 22.4316 36.1746 21.0684 34.4959 21.0684Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_10010_23954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4551 21.0684H37.5355V27.1591H31.4551V21.0684Z",
    fill: "#3D1F1E"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5713 24.5499C33.5713 23.817 34.1167 23.2887 34.8324 23.2887C34.15 23.2887 33.5718 22.726 33.5718 22.0269C33.5718 22.7193 33.0323 23.2887 32.3101 23.2887C33.0323 23.2887 33.5713 23.8436 33.5713 24.5499Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5713 22.0264L33.5718 22.0269M33.5718 22.0269C33.5718 22.726 34.15 23.2887 34.8324 23.2887C34.1167 23.2887 33.5713 23.817 33.5713 24.5499C33.5713 23.8436 33.0323 23.2887 32.3101 23.2887C33.0323 23.2887 33.5718 22.7193 33.5718 22.0269Z",
    stroke: "white",
    strokeWidth: 0.403264,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10010_23954",
    x1: 9.47441e-7,
    y1: 49.4599,
    x2: 63.9357,
    y2: 34.9374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10010_23954",
    x1: 22.5214,
    y1: 14.7646,
    x2: 22.5214,
    y2: 23.8512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10010_23954",
    x1: 28.0819,
    y1: 6.06445,
    x2: 28.0819,
    y2: 18.8623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10010_23954",
    x1: 33.8707,
    y1: 14.7646,
    x2: 33.8707,
    y2: 23.8512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTuto);
export default __webpack_public_path__ + "static/media/logo-tuto.4915004624988a34b86e87ce2aa22d2c.svg";
export { ForwardRef as ReactComponent };